export default {
	title: "O nas",
	description:
		"Dowiedz się więcej o Lean Customs. Kim jesteśmy, co robimy i naszą podróż. Jesteśmy brokerem celnym budującym przyszłość cyfrowych odpraw celnych.",

	story: {
		title: "Nasza historia",
		content: `
    <p>Lean Customs zostało założone w 2021 roku z celem stworzenia aplikacji do obsługi celnej przez brokerów celnych, dla brokerów celnych. Aplikacja, która obejmuje wszystkie aspekty: komunikację, obsługę celną, kontrakty, finanse, zgodność z przepisami, a wszystko to dostępne przez jedno API.</p>
    <p>Dostarczając jednocześnie usługi celne i budując środowisko, w którym te usługi są świadczone, Lean Customs tworzy unikalną przewagę nad konkurencją.</p>
    <p>Lean Customs rozpoczęło działalność z własnych środków i kontynuuje samodzielną działalność, budując przyszłość cyfrowych odpraw celnych.</p>`,
	},

	founders: {
		title: "Założyciele",
		description: "Lean Customs zostało założone w 2021 roku przez",
		founders: [
			{
				name: "Jaap van den Boogert",
				description: "Operacje",
			},
			{
				name: "Mickeal Schuurman",
				description: "Operacje",
			},
			{
				name: "Steef Timmermans",
				description: "Operacje",
			},
			{
				name: "Dirk Jonker",
				description: "Technologia",
			},
			{
				name: "Dmitry Kudryavtsev",
				description: "Technologia",
			},
			{
				name: "Leo Mangold",
				description: "Technologia",
			},
			{
				name: "Bart Koster",
				description: "Operacje",
			},
			{
				name: "Nico Timmermans",
				description: "Operacje",
			},
			{
				name: "Sjoerd Willemsen",
				description: "Operacje",
			},
		],
	},

	journey: {
		title: "Nasza podróż",
		content: [
			{ date: "Q4 2021", description: "Założenie Lean Customs" },
			{ date: "Q1 2022", description: "Certyfikacja AEO" },
			{
				date: "Q2 2022",
				description: "Miękki start Dexter, licencja na przedstawicielstwo fiskalne",
			},
			{ date: "Q3 2022", description: "Ponad milion przychodów miesięcznie" },
			{ date: "Q4 2022", description: "Uruchomienie RTTR, osobna jednostka oprogramowania" },
			{ date: "Q1 2023", description: "Licencje klienta ATR, T2L i PD" },
			{
				date: "Q2 2023",
				description: "W pełni cyfrowe kontrakty, pierwsza sprzedaż Dexter dla brokera celnego",
			},
			{ date: "Q3 2023", description: "Uruchomienie DMS" },
			{
				date: "Q4 2023",
				description: "Ponad 3 miliardy wartości odprawione przez Lean Operations",
			},
			{ date: "Q1 2024", description: "Uruchomienie API" },
		],
	},
};
